import { useMemo, useEffect } from 'react';
import { useAppDispatch } from 'hooks';
import { isAgencyBillingAvailable } from '../helpers';
import { PaymentOption } from '../types';

interface UseAgencyBillingProps {
  carrierSettings?: PaymentOption;
  paymentSchedule?: string;
  paymentMethodOptions?: Array<{ value: string; label: string }>;
  selectedPaymentMethod?: string;
  changeBillingAction: (payload: { name: string; value: string }) => any;
}

export const useAgencyBilling = ({
  carrierSettings,
  paymentSchedule,
  paymentMethodOptions,
  selectedPaymentMethod,
  changeBillingAction,
}: UseAgencyBillingProps) => {
  const dispatch = useAppDispatch();

  const isAgencyBillMode = useMemo(() => {
    return isAgencyBillingAvailable(carrierSettings, paymentSchedule);
  }, [carrierSettings, paymentSchedule]);

  const agencyConfig = useMemo(() => {
    if (!isAgencyBillMode) return null;

    return {
      name: 'Agency Bill Mode',
      description: 'Payment will be processed through agency billing.',
    };
  }, [isAgencyBillMode]);

  // Auto-select agency_bill when it's the only available payment method
  useEffect(() => {
    if (
      paymentMethodOptions?.length === 1 &&
      paymentMethodOptions[0].value === 'agency_bill' &&
      selectedPaymentMethod !== 'agency_bill'
    ) {
      dispatch(
        changeBillingAction({ name: 'payment_method', value: 'agency_bill' }),
      );
    }
  }, [
    paymentMethodOptions,
    selectedPaymentMethod,
    dispatch,
    changeBillingAction,
  ]);

  return {
    isAgencyBillMode,
    activeAgency: agencyConfig,
  };
};
